export default function typeSpecificOptions({ options, type }) {
  switch (type) {
    case 'circle':
      return { ...options, center: options.location }
    case 'polygon':
      return options
    case 'polyline':
      return options
    case 'wall':
      return { ...options, strokeColor: '#000000', strokeWeight: 4.5, zIndex: 106 }
    case 'rectangle':
      return options
    case 'label':
      return { ...options, enableEditMode: false }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/markups/typeSpecificOptions.js